import { render, staticRenderFns } from "./goodsRowSetting.vue?vue&type=template&id=cf8c5aec&scoped=true&"
import script from "./goodsRowSetting.vue?vue&type=script&lang=js&"
export * from "./goodsRowSetting.vue?vue&type=script&lang=js&"
import style0 from "./goodsRowSetting.vue?vue&type=style&index=0&id=cf8c5aec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8c5aec",
  null
  
)

export default component.exports